/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Stack } from "@mui/material";
import { NavigationItemTypes } from "@/src/types/Navigation.ts";
import NavItemCategory from "@/src/components/Header/NavItemCategory/NavItemCategory.tsx";
import NavItemLink from "@/src/components/Header/NavItemLink/NavItemLink.tsx";
import { navItemStyle } from "@/src/components/Header/NavItem/navItemStyle.ts";

export default function NavItem({ ...props }: NavigationItemTypes) {
  return (
    <Stack
      direction={"row"}
      component={"li"}
      sx={navItemStyle.navItem}
    >
      {props.type === "link" ? <NavItemLink {...props} /> : <NavItemCategory {...props} />}
    </Stack>
  );
}
